import { useState } from "react";
import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import LIcon from "@components/LIcon";
import { theme } from "@theme";

const Accordion = ({
  title,
  initialOpen = false,
  children,
  disableChevron = false,
}: {
  title: string;
  initialOpen?: boolean;
  children: React.ReactNode;
  disableChevron?: boolean;
}) => {
  const [expanded, setExpanded] = useState(initialOpen);
  return (
    <LBox gap="s3" mb={expanded ? "zero" : "zero"}>
      <LPressable
        disabled={disableChevron}
        onPress={() => setExpanded((prev) => !prev)}
        sentryEventName={`accordion_${title}`}
      >
        <LBox
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          borderBottomWidth={1}
          borderBottomColor="whiteTranslucent10"
          pb="s2"
        >
          <LText variant="Body/B1/Medium" color="lightGrey">
            {title}
          </LText>
          {!disableChevron && (
            <LIcon
              colors={{ color: theme.colors.lightGrey }}
              name="chevron"
              size={12}
              rotate={expanded ? 180 : 0}
            />
          )}
        </LBox>
      </LPressable>
      {expanded && <LBox>{children}</LBox>}
    </LBox>
  );
};

export default Accordion;
